module.exports = __webpack_public_path__ + "media/bj.9b6b4918.mp4";